<template>
    <div class="modal-full">
        <div class="modal-header">
            <close-icon v-on:click="closeView"></close-icon>
            <h1>Create Container</h1>
        </div>

        <div class="modal-body no-pad">
            <div class="flex h-full">
                <div class="account-sidebar h-full">
                    <div class="mb-4 text-center">
                        <span class="fa-layers fa-4x mb-3">
                            <i class="fa fa-circle"></i>
                            <i class="fas fa-user fa-inverse" data-fa-transform="shrink-6.5"></i>
                        </span>

                        <p class="text-lg font-light">New Container</p>
                    </div>

                    <div class="mb-3">

                    </div>
                </div>

                <div class="account-body">
                    <form class="profile-form">
                        <div class="form-title">
                            <p class="text-lg font-light">Container</p>
                        </div>

                        <div class="form-field">
                            <input type="text" v-model="container.name">
                            <label>Container Name</label>
                        </div>

                        <div class="form-field">
                            <input type="number" v-model="container.flags.max_accounts">
                            <label>Maximum number of accounts</label>
                        </div>

                        <div class="form-field">
                            <input type="text" v-model="container.domain">
                            <label>Domain</label>
                        </div>

                        <div class="form-field">
                            <select v-model="container.secure">
                                <option value="0">No</option>
                                <option value="1">Yes</option>
                            </select>
                            <label>Secure (Uses SSL)</label>
                        </div>

                        <div class="form-field">
                            <select v-model="container.public">
                                <option :value="false">No</option>
                                <option :value="true">Yes</option>
                            </select>
                            <label>Public Site Enabled?</label>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <div class="flex">
                <div class="left text-left">

                </div>

                <div class="right text-right">
                    <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>
                    <button class="btn-primary" type="button" @click="saveForm">Save</button>
                </div>
            </div>
        </div>
        <router-view v-slot="{ Component }">
            <transition name="drop-in" mode="in-out">
                <component :is="Component"></component>
            </transition>
        </router-view>
    </div>
</template>

<script>
export default {
    name: 'ContainerCreate',
    props: {
        //
    },
    data() {
        return {
            container: {
                name: null,
                domain: null,
                secure: 0,
                public: false,
                flags: {
                    max_accounts: null
                }
            },
        }
    },
    components: {
        //
    },
    computed: {
        //
    },
    mounted() {
        this.setMetaTitle('Create Container | JournoLink Control')
    },
    beforeDestroy() {
        //
    },
    methods: {
        /**
         * Emit the close event to the parent
         *
         * @return {void}
         */
        closeView() {
            this.setMetaTitle('List Containers | JournoLink Control')
            this.$root.goBack()
        },
        /**
         *
         */
        saveForm() {
            axios.post(route('containers.create'), this.container)
                .then(response => {
                    this.container = response.data.container
                    this.$bus.$emit('alert.success', 'New Container has been created')
                    this.$router.push({name: 'containers.list', params: {newContainer: this.container}})
                })
                .catch(e => {
                    console.error({e})
                })
        },
        /**
         * Handle an [Escape] keypress
         *
         * @return {void}
         */
        onEscapeKeypress() {
            this.closeView()
        },
    },
}
</script>

<style lang="less">
.account-sidebar {
    padding: 15px;
    width: 350px;
    font-size: 0.9rem;
    background: #f6f6f6;

    label {
        font-weight: bold;
        font-size: 0.8em;
        color: #999999;
    }

    p {
        margin-bottom: 0.5em;
    }
}

.account-activity {
    width: 250px;
    font-size: 0.9rem;
    padding: 15px;
}

.hidden-input {
    input {
        display: none;
        width: 100%;
    }

    .show {
        display: inline-block;
    }

    .hide {
        display: none;
    }

    .edit-field-link {
        text-decoration-line: underline;
        text-decoration-style: solid;
        color: #222222;
        word-wrap: break-word;
    }
}

.profile-form {
    .section-title {
        margin-top: 20px;
    }

    .form-title {
        margin-bottom: 20px;
    }
}
</style>
